import { cancellationSelectorsFactory } from 'state/secondaryMarket/shared/cancellation/cancellationSelectorsFactory';

export const liveCancellationSelectors = cancellationSelectorsFactory('live');
